(() => {
  if (customElements.get('miruka-activity')) return;

  const states = new Map();
  const delay = (minimum, maximum) => minimum + Math.floor(Math.random() * (maximum - minimum));

  class MirukaActivity extends HTMLElement {
    connectedCallback() {
      this.count = this.querySelector('[data-miruka-viewers]');
      this.stock = this.querySelector('[data-miruka-availability]');
      this.bar = this.querySelector('[data-miruka-availability-bar]');
      if (!this.count || !this.stock || !this.bar) return;

      this.key = this.dataset?.productId || 'miruka-product';
      this.state = states.get(this.key) || { viewers: 20, availability: 7 };
      states.set(this.key, this.state);
      this.count.textContent = String(this.state.viewers);
      this.stock.textContent = String(this.state.availability);
      this.bar.style.width = `${this.state.availability * 10}%`;

      window.clearTimeout(this.viewerTimer);
      window.clearTimeout(this.stockTimer);
      this.viewerTimer = window.setTimeout(() => this.updateViewers(), delay(3000, 5000));
      if (this.state.availability > 1) {
        this.stockTimer = window.setTimeout(() => this.updateStock(), delay(65000, 95000));
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.viewerTimer);
      window.clearTimeout(this.stockTimer);
    }

    animateNumber(element, value) {
      if (element.textContent === String(value)) return;
      element.textContent = String(value);
      element.classList.remove('miruka-activity__number--updated');
      void element.offsetWidth;
      element.classList.add('miruka-activity__number--updated');
    }

    updateViewers() {
      if (!document.hidden) {
        const current = this.state.viewers;
        const direction = current <= 17 ? 1 : current >= 24 ? -1 : Math.random() < .7 ? 1 : -1;
        this.state.viewers = current + direction;
        this.animateNumber(this.count, this.state.viewers);
      }
      this.viewerTimer = window.setTimeout(() => this.updateViewers(), delay(9000, 15000));
    }

    updateStock() {
      if (!document.hidden && this.state.availability > 1) {
        this.state.availability -= 1;
        this.animateNumber(this.stock, this.state.availability);
        this.bar.style.width = `${this.state.availability * 10}%`;
      }
      if (this.state.availability > 1) {
        this.stockTimer = window.setTimeout(() => this.updateStock(), delay(65000, 95000));
      }
    }
  }

  customElements.define('miruka-activity', MirukaActivity);
})();
